import { Observable, map, of, shareReplay, takeWhile, timer } from 'rxjs';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countdown',
  standalone: true,
})
export class CountdownPipe implements PipeTransform {

  transform(value?: string, delay = false, eventName?: string): Observable<string> {
    // console.log(`countdown:value:${eventName}`, value)
    if (!value) return of(String(value));

    // value = String(value).split(" ")[0];
    // console.log(`countdown:value:${eventName}`, value)

    if (!value.includes('MTP')) return of(value);

    let secondsRemaining = (Number(String(value).split(" ")[0]) * 60);

    let oldMinutes: any;

    return timer(0, 1000).pipe(
      takeWhile(() => secondsRemaining !== -1),
      map(() => {
        secondsRemaining -= 1;

        // console.log(`countdown:formatTime1:${eventName}`, secondsRemaining)
        const minutes = Math.round((secondsRemaining / 60));
        // const seconds = Math.floor((secondsRemaining / 60 * 1000));

        // console.log(`countdown:formatTime2:minutes:${eventName}`, Math.floor((secondsRemaining / 60)))
        // console.log(`countdown:formatTime2:minutes:${eventName}`, Math.round((secondsRemaining / 60)))
        // console.log(`countdown:formatTime2:minutes:${eventName}`, minutes)
        // console.log(`countdown:formatTime2:minutes:${eventName}`, minutes)

        // console.log(`countdown:formatTime2:secondsRemaining:${eventName}`, secondsRemaining)

        if (value.includes('MTP')) return `${minutes.toString()} MTP`;

        if (delay) {
          setTimeout(() => {
            oldMinutes = minutes;
            return `${minutes.toString()}`;
          }, 10000);
          return `${oldMinutes.toString()}`;
        }
        else {
          oldMinutes = minutes;
          return `${minutes.toString()}`;
        }



      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  // private formatTime(ms: number): string {
  //   console.log(`countdown:formatTime:`, ms)
  //   // const hours = Math.floor(ms / (1000 * 60 * 60));
  //   const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  //   // const seconds = Math.floor((ms % (1000 * 60)) / 1000);

  //   console.log('countdown:formatTime:', minutes)

  //   return `${minutes.toString()}`;
  // }

}
